import React, { useEffect, useState } from "react";
import { Input, Button } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const VarifyOTP = () => {
    const navigate = useNavigate();
    const [otp, setOtp] = useState("");
    const [timeLeft, setTimeLeft] = useState(0);
    const [loading, setLoading] = useState(false);
    const [resending, setResending] = useState(false);

    const forgotEmail = JSON.parse(secureLocalStorage.getItem("forgot_email"));

    useEffect(() => {
        if (!forgotEmail) {
            toast.info("Session expired. Please go back and try again.");
            navigate("/");
            return;
        }

        const storedExpiry = localStorage.getItem("otpExpiry");
        if (storedExpiry) {
            const expiryTime = parseInt(storedExpiry, 10);
            const now = Date.now();
            if (expiryTime > now) {
                setTimeLeft(Math.floor((expiryTime - now) / 1000));
            } else {
                setTimeLeft(0);
            }
        } else {
            const expiry = Date.now() + 600 * 1000;
            localStorage.setItem("otpExpiry", expiry);
            setTimeLeft(600);
        }
    }, [forgotEmail, navigate]);

    useEffect(() => {
        if (timeLeft <= 0) return;
        const interval = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, [timeLeft]);

    const formatTime = (seconds) => {
        const m = String(Math.floor(seconds / 60)).padStart(2, "0");
        const s = String(seconds % 60).padStart(2, "0");
        return `${m}:${s}`;
    };

    const handleOtpChange = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        if (value.length <= 6) setOtp(value);
    };

    const verifyOtp = async () => {
        if (otp.length !== 6) {
            toast.error("Please enter a 6-digit OTP");
            return;
        }
        setLoading(true);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}api/verify-otp`,
                { otp, email: forgotEmail },
                { headers: { "Content-Type": "application/json" } }
            );
            if (res.data.status === true) {
                toast.success("OTP Verified Successfully!");
                setTimeout(() => {
                    navigate('/update-password')
                }, 1000)
            } else {
                toast.error(res?.data?.message || "Invalid OTP");
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error verifying OTP");
        } finally {
            setLoading(false);
        }
    };

    const resendOtp = async () => {
        setResending(true);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}api/resend-otp`,
                { email: forgotEmail },
                { headers: { "Content-Type": "application/json" } }
            );
            if (res.data.status === true) {
                toast.success("OTP Resent Successfully!");
                setOtp("");
                const expiry = Date.now() + 600 * 1000;
                localStorage.setItem("otpExpiry", expiry);
                setTimeLeft(600);
                // setTimeout(() => {
                //     navigate('/update-password')
                // }, 1000)
            } else {
                toast.error(res.data.message || "Failed to resend OTP");
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error resending OTP");
        } finally {
            setResending(false);
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100 px-4">
            <div className="bg-white shadow-lg rounded-xl p-8 max-w-md w-full text-center">
                <h2 className="text-2xl font-bold mb-2 text-brandBlue">Verify OTP</h2>
                <p className="text-gray-600 mb-6">
                    Please enter the 6-digit code sent to your email.
                </p>

                <Input
                    value={otp}
                    onChange={handleOtpChange}
                    maxLength={6}
                    placeholder="Enter 6-digit OTP"
                    className="text-center text-lg tracking-widest font-bold"
                />

                {timeLeft > 0 ? (
                    <p className="mt-3 text-sm text-gray-500">
                        OTP expires in:{" "}
                        <span className="font-semibold text-red-500">
                            {formatTime(timeLeft)}
                        </span>
                    </p>
                ) : (
                    <p className="mt-3 text-sm text-red-500 font-semibold">
                        OTP has expired. Please request a new one.
                    </p>
                )}

                <div className="mt-6 flex flex-col gap-3">
                    <Button
                        type="primary"
                        className="bg-brandBlue"
                        onClick={verifyOtp}
                        loading={loading}
                        disabled={timeLeft <= 0}
                    >
                        Verify OTP
                    </Button>
                    <Button
                        type="default"
                        onClick={resendOtp}
                        loading={resending}
                        disabled={timeLeft > 0}
                    >
                        Resend OTP
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default VarifyOTP;
